'use strict';
import angular from 'angular';
import './scripts/queues.ctrls';
import './scripts/queues.services';

import myqueuesHtmlUrl from './views/myqueues.html';
import queueManagerHtmlUrl from './views/queueManager.html';
import adminQueuesHtmlUrl from './views/adminQueues.html';
import addAdminQueuesHtmlUrl from './views/addAdminQueues.html';


angular.module('queues', [
    'queues.ctrls',
    'queues.services'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('myQueues', {
                parent: 'layout',
                url: '/items/myQueues?queueId',
                templateUrl: myqueuesHtmlUrl,
                controller: 'MyQueuesController',
                params: {
                    filter: null
                }
            })
            .state('queueManager', {
                parent: 'layout',
                url: '/items/queueManager',
                templateUrl: queueManagerHtmlUrl,
                controller: 'QueueManagerController'
            })
            .state('adminQueues', {
                parent: 'layout',
                url: '/admin/queues',
                templateUrl: adminQueuesHtmlUrl,
                controller: 'AdminQueuesController'
            })
            .state('addAdminQueues', {
                parent: 'layout',
                url: '/admin/queues/add',
                templateUrl: addAdminQueuesHtmlUrl,
                controller: 'AddAdminQueuesController',
                params: {
                    comeFrom: null,
                    'taskInfo': null,
                }
            })
            .state('editAdminQueues', {
                parent: 'layout',
                url: '/admin/queues/edit/:id',
                templateUrl: addAdminQueuesHtmlUrl,
                controller: 'AddAdminQueuesController'
            })
    }]);